// src/PageViewTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from './analytics';

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // With HashRouter, useLocation().pathname is already the path inside the hash.
    // This will produce "/register" for http://localhost:3000/#/register
    const path = location.pathname + location.search + location.hash;
    pageview(path);
  }, [location]);

  return null;
}
